import axiosInstanceClient from '../Common/Axios/axiosInstanceClient';
import API from '../Common/Endpoint/serviceConstrants';
export const callLoginUserApi = async (payload) => {
    const { data = {} } = await axiosInstanceClient.post(API.login, payload);
    return data;
};

export const callResetPasswordApi = async (payload) => {
    const { data = {} } = await axiosInstanceClient.post(API.resetPassword, {
        token: payload?.token,
        newPassword: payload?.newPassword,
    });
    return data;
};

export const callAdminLoginApi = async (payload) => {
    const { data = {} } = await axiosInstanceClient.post(API.adminLogin, {
        email: payload?.email,
        password: payload?.password,
    });
    return data;
};